import React from 'react';
import { observer } from 'mobx-react-lite';
import { getStringFullDate } from 'utils/getStringDate';

import { useStores } from 'hooks/useStores';
import { PublicationDateContainer } from './PublicationDateStyles';

const PublicationDate = observer(({ className }) => {
  const {
    advertsStore: { currentAdvert },
  } = useStores();

  return (
    <PublicationDateContainer className={className}>
      {getStringFullDate(currentAdvert.date_publication_from)}
    </PublicationDateContainer>
  );
});

export default PublicationDate;
